/**
 * PayPay表示制御ユーティリティ
 *
 * 本番環境ではPayPayを非表示にし、Kishユーザーのみテスト可能にする
 *
 * 表示条件:
 * 1. 環境変数 NEXT_PUBLIC_ENABLE_PAYPAY が 'true'
 * OR
 * 2. currentUser.role === 'kish'
 */

/**
 * PayPayを表示すべきかどうかを判定
 * @param userRole ユーザーのrole (未ログインの場合はundefined)
 * @returns PayPayを表示すべきかどうか
 */
export const isPaypayEnabled = (userRole?: string | null): boolean => {
  // 環境変数でPayPayが有効化されている場合
  if (process.env.NEXT_PUBLIC_ENABLE_PAYPAY === 'true') {
    return true
  }

  // Kishユーザーの場合（本番テスト用）
  if (userRole === 'kish') {
    return true
  }

  return false
}
